var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBattery23Full(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.75 14.5c0-.41.34-.75.75-.75.59 0 .72-.09.73-.09.02-.06.02-.41.02-.66v-2c0-.25 0-.59-.04-.68-.01.01-.16-.07-.71-.07-.41 0-.75-.34-.75-.75s.34-.75.75-.75c2.08 0 2.25 1.02 2.25 2.25v2c0 1.23-.17 2.25-2.25 2.25-.41 0-.75-.34-.75-.75zM6.2 14.73c-.4-.1-.65-.51-.55-.91.3-1.19.3-2.45 0-3.64a.748.748 0 1 1 1.45-.36c.36 1.43.36 2.94 0 4.36-.08.34-.39.57-.72.57-.06 0-.12-.01-.18-.02zM9.7 14.73c-.4-.1-.65-.51-.55-.91.3-1.19.3-2.45 0-3.64-.1-.4.14-.81.55-.91.4-.1.81.14.91.55.36 1.43.36 2.94 0 4.36-.09.34-.4.57-.73.57-.06 0-.12-.01-.18-.02z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 19.75c-4.41 0-5.75-1.34-5.75-5.75v-4c0-4.41 1.34-5.75 5.75-5.75h6c4.41 0 5.75 1.34 5.75 5.75v4c0 4.41-1.34 5.75-5.75 5.75H7zM2.75 10v4c0 3.57.68 4.25 4.25 4.25h6c3.57 0 4.25-.68 4.25-4.25v-4c0-3.57-.68-4.25-4.25-4.25H7c-3.57 0-4.25.68-4.25 4.25z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBattery23Full);
export default __webpack_public_path__ + "static/media/vuesax-outline-battery-2-3-full.a6d9d87239e00b99d29d48bcc76f6bc7.svg";
export { ForwardRef as ReactComponent };